import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import SearchableDropdown from "../../../myfin_v2/elements/SearchableDropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as DeleteGreyIcon } from "../../../myfin_v2/assets/icons/deleteGrey.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";


const CreateEntryModal = ({ handleClose }) => {

    const particularOptions = [
        "Purchase Order",
        "Purchase Invoice",
        "Purchase Return",
        "Vendor Payment",
        "Advance to Vendor",
        "Expense Claim",
        "Utility Bill",
        "Rent Payment",
        "Goods Receipt Note",
        "Import Charges",
    ];

    const [particulars, setParticulars] = useState([
        { particular: "", currentAmount: "", previousAmount: "" },
    ]);

    const handleAddParticular = () => {
        setParticulars([
            ...particulars,
            { particular: "", currentAmount: "", previousAmount: "" },
        ]);
    };

    const handleRemoveParticular = (indexToRemove) => {
        setParticulars(particulars.filter((_, i) => i !== indexToRemove));
    };

    const handleChange = (index, field, value) => {
        const updated = [...particulars];
        updated[index][field] = value;
        setParticulars(updated);
    };

    return (
        <>
            <Modal
                width="650px"
                title="Create Entry"
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label="Create Entry"
                        />
                    </>
                }
            >
                <div className={commoncss.pd1530}>
                    <InputGroup
                        label="Choose Date"
                        inputs={[
                            <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                        <MobileDatePicker
                                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                            format="DD-MMM-YYYY"
                                            slotProps={{
                                                textField: {
                                                    InputProps: {
                                                        disableUnderline: true,
                                                    },
                                                    inputProps: {
                                                        placeholder: "DD-MM-YYYY",
                                                    },
                                                    sx: {
                                                        '& fieldset': {
                                                            border: 'none',
                                                        },
                                                    },
                                                },
                                            }}
                                        />

                                    </DemoContainer>
                                </LocalizationProvider>
                                <span className="icon">
                                    <CalenderIcon
                                        className="vaMiddle"
                                        width={20}
                                        height={20}
                                    />
                                </span>
                            </>,
                        ]}
                    />
                    <InputGroup
                        label="Remarks"
                        inputs={[
                            <>
                                <textarea
                                    rows={3}
                                    placeholder="Enter remarks"
                                />
                            </>,
                        ]}
                    />
                    {particulars.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                border: "1px solid #EAEEED",
                                padding: "10px",
                                borderRadius: "10px",
                                marginTop: "15px",
                            }}
                        >
                            <InputGroup
                                label={
                                    <div className="attachments-button-label mb-2">
                                        <span>Particulars</span>
                                        <div>
                                            {particulars.length > 1 && (
                                                <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleRemoveParticular(index)}
                                                >
                                                    <DeleteGreyIcon />
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                }
                                inputs={[
                                    <>
                                        <SearchableDropdown
                                            name="particular"
                                            options={particularOptions}
                                            defaultValue={item.particular}
                                            onSelect={(val) =>
                                                handleChange(index, "particular", val)
                                            }
                                        />
                                    </>,
                                ]}
                            />
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <InputGroup
                                        label="Current Year Amount"
                                        inputs={[
                                            <>
                                                <input
                                                    type="text"
                                                    value={item.currentAmount}
                                                    onChange={(e) =>
                                                        handleChange(index, "currentAmount", e.target.value)
                                                    }
                                                />
                                            </>,
                                        ]}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <InputGroup
                                        label="Previous Year Amount"
                                        inputs={[
                                            <>
                                                <input
                                                    type="text"
                                                    value={item.previousAmount}
                                                    onChange={(e) =>
                                                        handleChange(index, "previousAmount", e.target.value)
                                                    }
                                                />
                                            </>,
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* <div style={{ border:"1px solid #EAEEED", padding:"10px", borderRadius:"10px" }}>
                        <InputGroup
                            label={
                                <div className="attachments-button-label mb-2">
                                    <span>Particulars</span>
                                    <div>
                                        <span style={{ cursor:"pointer" }}><DeleteGreyIcon /></span>
                                    </div>
                                </div>
                            }
                            inputs={[
                                <>
                                    <SearchableDropdown
                                        name="particular"
                                        options={particularOptions}
                                        defaultValue=""
                                        onSelect={(val) => {
                                            console.log("module name val", val);
                                        }}
                                    />
                                </>,
                            ]}
                        />
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <InputGroup
                                    label="Current Year Amount"
                                    inputs={[
                                        <>
                                            <input
                                                type="text"
                                            />
                                        </>,
                                    ]}
                                />
                            </div>
                            <div className="col-md-6">
                                <InputGroup
                                    label="Previous Year Amount"
                                    inputs={[
                                        <>
                                            <input
                                                type="text"
                                            />
                                        </>,
                                    ]}
                                />
                            </div>
                        </div>
                    </div> */}

                    <div onClick={handleAddParticular} style={{ color:"#2D8861", fontSize:"14px", marginTop:"10px", cursor:"pointer" }}>
                        <PlusPrimaryIcon /> Add Field
                    </div>
                </div>


            </Modal>

        </>
    )
}


export default CreateEntryModal;